import React, { useEffect, useState } from "react";
import { BarChart, Bar, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { DollarSign, TrendingUp, Target, Trophy } from "lucide-react";
import AppLayout from "@/components/AppLayout";
import api from "@/lib/api";

const rm = (n) => "RM " + (n || 0).toLocaleString("en-MY");

export default function Analytics() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/analytics").then((r) => setData(r.data)); }, []);
  if (!data) return <AppLayout active="analytics"><div className="animate-pulse text-muted-foreground font-mono">Loading analytics…</div></AppLayout>;

  return (
    <AppLayout active="analytics">
      <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight mb-6">Analytics & Sales Attribution</h1>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {[["Revenue", rm(data.revenue), DollarSign, "text-emerald-400"], ["Ad Spend", rm(data.ad_spend), Target, "text-amber-400"], ["Live ROAS", data.roas + "x", TrendingUp, "text-cyan-400"], ["Won Deals", data.won, Trophy, "text-[#E5253A]"]].map(([k, v, Icon, c]) => (
          <div key={k} data-testid={`analytics-${k.toLowerCase().replace(" ", "-")}`} className="rounded-xl border border-border bg-card p-5">
            <div className="flex items-center justify-between"><span className="text-xs text-muted-foreground">{k}</span><Icon className={`h-4 w-4 ${c}`} /></div>
            <div className="mt-3 text-2xl font-mono font-bold">{v}</div>
          </div>
        ))}
      </div>

      <div className="grid lg:grid-cols-2 gap-6 mt-6">
        <div className="rounded-xl border border-border bg-card p-5">
          <h3 className="font-bold mb-4">Conversion Funnel</h3>
          <ResponsiveContainer width="100%" height={240}>
            <BarChart data={data.funnel} layout="vertical">
              <XAxis type="number" hide />
              <YAxis type="category" dataKey="stage" width={70} stroke="hsl(var(--muted-foreground))" fontSize={12} tickLine={false} axisLine={false} />
              <Tooltip contentStyle={{ background: "hsl(var(--card))", border: "1px solid hsl(var(--border))", borderRadius: 8, fontSize: 12 }} />
              <Bar dataKey="value" fill="#E5253A" radius={[0, 6, 6, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div className="rounded-xl border border-border bg-card p-5">
          <h3 className="font-bold mb-4">Attribution by Session</h3>
          <div className="space-y-2">
            {data.attribution.map((a, i) => (
              <div key={i} data-testid={`attr-row-${i}`} className="flex items-center justify-between rounded-lg border border-border px-4 py-2.5">
                <div className="min-w-0">
                  <div className="text-sm font-medium truncate">{a.session}</div>
                  <div className="text-[10px] text-muted-foreground font-mono">{a.host} · {a.leads} leads · {a.sales} sales</div>
                </div>
                <span className="text-sm font-mono font-bold text-emerald-400 shrink-0 ml-3">{rm(a.revenue)}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </AppLayout>
  );
}
